module.exports = __webpack_public_path__ + "img/ocrover_ok.png";